import React from "react";

import Layout from "../components/Layout";

const Error = () => {
  return (
    <Layout>
      <div className="not-found">Page not found</div>
    </Layout>
  );
};

export default Error;
